import { useGroupCampaigns } from '@hobbytools/data';
import { appUrl, systemAppId } from '@hobbytools/platform';
import { Badge, Button, Card } from '@hobbytools/ui';

/** The group's campaigns, each linking into the app of its game system (a full page load, ADR 0008). */
export function GroupCampaigns({ groupId, canCreate }: { groupId: string; canCreate: boolean }) {
  const campaigns = useGroupCampaigns(groupId);
  const list = campaigns.data ?? [];

  return (
    <Card className="flex flex-col gap-3">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <h2 className="heading-display text-xl">Campaigns</h2>
        {canCreate ? (
          <a href={appUrl('w40k', `/campaigns/new?group=${groupId}`)} className="contents">
            <Button size="sm" variant="secondary">
              New campaign
            </Button>
          </a>
        ) : null}
      </div>
      {campaigns.isLoading ? (
        <p className="text-sm text-fg-muted">Loading campaigns…</p>
      ) : list.length === 0 ? (
        <p className="text-sm text-fg-muted">No campaigns yet.</p>
      ) : (
        <ul className="flex flex-col divide-y divide-border">
          {list.map((c) => {
            const app = systemAppId(c.system);
            return (
              <li key={c.id} className="flex min-h-touch flex-wrap items-center gap-2 py-2">
                {app ? (
                  <a
                    href={appUrl(app, `/campaigns/${c.id}`)}
                    className="font-medium text-fg underline-offset-2 hover:underline"
                  >
                    {c.name}
                  </a>
                ) : (
                  <span className="font-medium">{c.name}</span>
                )}
                {c.archived_on ? <Badge>Archived</Badge> : null}
              </li>
            );
          })}
        </ul>
      )}
    </Card>
  );
}
